import { Box, Button, Divider, Group, MultiSelect, SegmentedControl, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import CustomDatePicker from "core/components/datePicker/CustomDatePicker";
import { FormInputWrapper } from "core/components/index";
import moment from "moment";
import { useCallback, useMemo } from "react";
import { getClientLabel, getCompany } from "utils/helper";
import { logger } from "utils/logger";

// Helper function to convert column accessor to filter field name
const getFilterFieldName = (accessor) => {
    // Convert accessor to camelCase filter field name
    // e.g., 'STYLE NO' -> 'styleNo', 'VARIATION SIZE' -> 'variationSize'
    return accessor
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim()
        .replace(/\s+(\w)/g, (_, c) => c.toUpperCase())
        .replace(/^./, c => c.toLowerCase());
};

// Helper function to check if a column should be filterable
const isFilterableColumn = (column) => {
    // Skip expander columns, action columns, and date columns (handled separately)
    if (!column.accessor || column.accessor === 'expander' || column.accessor === 'action') {
        return false;
    }
    // Date columns are handled separately
    if (column.Header && (column.Header.toLowerCase().includes('date') || column.Header.toLowerCase().includes('otb'))) {
        return false;
    }
    return true;
};

const SeasonMastersStyleFilterPanel = ({ onCancel, onApply, filter, filterItems, columns = [], aggData }) => {
    const company = getCompany(aggData);
    logger.log(filter);
    const form = useForm({
        initialValues: {
            ...filter,
            otbDate: {
                dateStart: filter.otbDate?.dateStart?.toString().length ? moment(filter.otbDate?.dateStart).toDate() : '',
                dateEnd: filter.otbDate?.dateEnd?.toString().length ? moment(filter.otbDate?.dateEnd).toDate() : '',
            },
        },
    });

    // Get filterable columns (excluding date columns)
    const filterableColumns = useMemo(() => {
        return columns.filter(isFilterableColumn);
    }, [columns]);

    // Get date columns
    const dateColumns = useMemo(() => {
        return columns.filter(col => 
            col.Header && (col.Header.toLowerCase().includes('date') || col.Header.toLowerCase().includes('otb'))
        );
    }, [columns]);

    const getFilterVars = useCallback(
        (key) => {
            var res = [];
            if (filterItems[key]) Object.keys(filterItems[key]).forEach((val) => res.push(val));
            return res.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
        },
        [filter, filterItems],
    );

    return (
        <Box shadow='xs' style={{ width: '100%' }}>
            <form onSubmit={(e) => {
                e.preventDefault();
                
            }}>
                <Box pr={'md'} style={{ height: 400, overflow: 'auto', marginRight: -15 }}>
                    {/* Dynamically generate filter fields based on columns */}
                    {filterableColumns.map((column) => {
                        const filterFieldName = getFilterFieldName(column.accessor);
                        const filterKey = filterItems[filterFieldName] ? filterFieldName : 
                                         filterItems[column.accessor] ? column.accessor : null;
                        
                        // Skip if no filter items available for this column
                        if (!filterKey) return null;

                        return (
                            <FormInputWrapper key={column.accessor} label={column.Header || column.accessor} labelWidth={'130px'}>
                                <MultiSelect 
                                    data={getFilterVars(filterKey)} 
                                    label='' 
                                    placeholder='Pick all that you like' 
                                    searchable 
                                    nothingFound='Nothing found' 
                                    {...form.getInputProps(filterFieldName)} 
                                />
                            </FormInputWrapper>
                        );
                    })}

                    {/* Date filters */}
                    {dateColumns.map((column) => {
                        const filterFieldName = getFilterFieldName(column.accessor) + 'Date';
                        return (
                            <FormInputWrapper key={column.accessor} label={column.Header || getClientLabel(company, 'otbDate')} id={`input-${filterFieldName}`} labelWidth={'130px'}>
                                <Group noWrap>dfdf
                                    <CustomDatePicker 
                                        sx={{ width: 180 }} 
                                        placeholder={`From ${column.Header || 'Date'}`} 
                                        {...form.getInputProps(`${filterFieldName}.dateStart`)} 
                                    />
                                    <Text>to</Text>
                                    <CustomDatePicker 
                                        sx={{ width: 180 }} 
                                        placeholder={`To ${column.Header || 'Date'}`} 
                                        {...form.getInputProps(`${filterFieldName}.dateEnd`)} 
                                    />
                                </Group>
                            </FormInputWrapper>
                        );
                    })}

                    {/* Fallback OTB Date if no date columns found */}
                    {/* {dateColumns.length === 0 && (
                        <FormInputWrapper label='OTB Date' id='input-otbdate' labelWidth={'130px'}>
                            <Group noWrap>
                                <CustomDatePicker sx={{ width: 180 }} placeholder='From OTB Date' {...form.getInputProps('otbDate.dateStart')} />
                                <Text>to</Text>
                                <CustomDatePicker sx={{ width: 180 }} placeholder='To OTB Date' {...form.getInputProps('otbDate.dateEnd')} />
                            </Group>
                        </FormInputWrapper>
                    )} */}
                </Box>
                <Divider />
                <Group position='apart' mt='sm'>
                    <Button variant='subtle' component='button' size='sm' onClick={() => onCancel()}>
                        Cancel
                    </Button>
                    <Button size='sm' onClick={() => onApply(form.values)}>
                        Apply
                    </Button>
                </Group>
            </form>
        </Box>
    );
};

export default SeasonMastersStyleFilterPanel;